<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [style]="{ width: '70vw' }"
>
  <ng-template #header>
    <h2>{{'contacts.mergeContatcs' | transloco}}</h2>
  </ng-template>
  <div class="grid grid-cols-12 gap-2">
    @for (field of allFields; track field) {
      <div [ngClass]="'col-span-' + fieldColSpanMap[field]">
        <p-inputgroup>
          <p-iftalabel>
            <label class="py-1 d-block" [attr.for]="'contact-' + field">
              {{ 'contacts.' + field | transloco }}
            </label>
            @if (conflictingFields[field]) {
              <p-select
                class="p-inputdropdown-sm w-full"
                [options]="dropdownOptions[field]"
                [(ngModel)]="mergedContact[field]"
                (ngModelChange)="onInputChange(field)"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'contacts.selectValue' | transloco"
                [styleClass]="(isFieldInvalid(field) ? ' ng-invalid ng-dirty' : '')"
              />
            } @else if (field === 'birthday') {
              <input
                type="text"
                pInputText
                class="p-inputtext-sm w-full"
                [id]="'contact-' + field"
                [value]="mergedContact[field] ? formatBirthday(mergedContact[field]) : ''"
                [disabled]="true"
              />
            } @else {
              <input
                type="text"
                pInputText
                class="p-inputtext-sm w-full"
                [id]="'contact-' + field"
                [(ngModel)]="mergedContact[field]"
                (ngModelChange)="onInputChange(field)"
                [disabled]="!conflictingFields[field]"
              />
            }
          </p-iftalabel>
        </p-inputgroup>
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="flex gap-2">
      <p-button
        icon="pi pi-times"
        label="{{ 'contacts.cancel' | transloco }}"
        [text]="true"
        (click)="cancel()"/>
      <p-button
        label="{{ 'modal.save' | transloco }}"
        icon="pi pi-pen-to-square"
        (click)="confirm()"
        [disabled]="hasInvalidFields()"
      />
    </div>
  </ng-template>
</p-dialog>
